import { useFrameViewportCssVars } from '../lib/frameViewport';

/**
 * Tracks which part of a tall host frame is on screen and publishes it as CSS
 * variables, so dialogs and snackbars open where the person is looking.
 */
export function FrameViewportSync() {
  useFrameViewportCssVars();
  return null;
}
